import React from "react";
import Loader from "./Loader";
import Forecast1 from "./Forecast1";
import Bolo from "./Bolo";
import Fuente from "./Fuente";

import moment from "moment";

const boloPrediccion = <Bolo texto="Predicción" />;

const ForecastView = props => (
	<div className="ForecastView">
		{moment(props.dia_act).isBefore(moment().add(5, "d")) ? boloPrediccion : ""}
		{props.loading ? (
			<Loader />
		) : (
			<div className="forecast-day">
				{props.forecast.map(
					(item, index) =>
						moment(item.date).isSame(moment(props.dia_act), "day") ? (
							<Forecast1 key={index} {...item} />
						) : (
							""
						)
				)}
			</div>
		)}
		{moment(props.dia_act).isBefore(moment().add(5, "d")) ? <Fuente /> : ""}
	</div>
);

export default ForecastView;



// WEBPACK FOOTER //
// ./src/components/ForecastView.js